module.exports = __webpack_public_path__ + "img/passport_zh-hk.8f688417.png";